/* ------ ADD TO CART ------ */
// The cart drawer is a modal dialog, so a status message outside it isn't read while it's open
function cartStatusRegion() {
    const cart = document.getElementById("rebuy-cart");
    if (!cart) return document.getElementById("CartStatus");
    let region = cart.querySelector("[data-cart-status]");
    if (!region) {
        region = document.createElement("div");
        region.className = "visually-hidden";
        region.setAttribute("role", "status");
        region.setAttribute("aria-live", "polite");
        region.setAttribute("aria-atomic", "true");
        region.setAttribute("data-cart-status", "");
        region.id = "RebuyCartStatus";
        cart.prepend(region);
    }
    // Read as the drawer's description when focus moves into it
    const describedBy = (cart.getAttribute("aria-describedby") || "").split(" ").filter(Boolean);
    if (!describedBy.includes(region.id)) {
        describedBy.unshift(region.id);
        cart.setAttribute("aria-describedby", describedBy.join(" "));
    }
    return region;
}

// Set before the drawer opens so the message is read with the drawer when focus moves into it
function announceCartStatus(message) {
    if (!message) return;
    const region = cartStatusRegion();
    if (!region) return;
    region.textContent = message;
    clearTimeout(announceCartStatus.timer);
    announceCartStatus.timer = setTimeout(() => {
        region.textContent = "";
    }, 10000);
}

function cartAddedMessage(item) {
    const strings = (window.FoxTheme && FoxTheme.cartStrings) || {};
    const added = strings.itemAdded || "Item added to your cart";
    if (!item || !item.product_title) return added;
    let title = item.product_title;
    if (item.variant_title) title += " - " + item.variant_title;
    return title + ". " + added;
}

document.addEventListener("product-ajax:added", function (e) {
    announceCartStatus(cartAddedMessage(e.detail && e.detail.product));
});

// used on PLP atc button
document.addEventListener("click", function (e) {

    const btn = e.target.closest(".add-to-cart");
    if (!btn) return; // not an add-to-cart button

    const variantId = Number(btn.getAttribute("data-variant-id"));
    const metaText = btn.getAttribute("data-variant-lineitem");

    const data = {
        id: variantId,
        quantity: 1,
        properties: {}
    };

    // Add metafield value as a line item property if it exists
    if (metaText && metaText.trim() !== "") {
        data.properties["ships_on"] = metaText;
    }

    // Shopify AJAX add to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    })
    .then((res) => res.json().then((item) => ({ ok: res.ok, item })))
    .then(({ ok, item }) => {
        if (ok) {
            announceCartStatus(cartAddedMessage(item));
        } else {
            const strings = (window.FoxTheme && FoxTheme.cartStrings) || {};
            announceCartStatus((strings.error || "Error") + ": " + (item.description || item.message || ""));
        }
        Rebuy.SmartCart.show();
    })
    .catch((error) => {
        console.error("Error adding product to cart:", error);
    });
});

/* ------ Header hide after Xpx, works with sections above header ------ */
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-sticky');
  if (!header) return;

  // Function to get all .shopify-section elements above the header
  function getSectionsAboveHeader() {
    return Array.from(document.querySelectorAll('.shopify-section'))
      .filter(section => section.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  // Function to calculate total height of sections above header
  function calculateHeight(sections) {
    return sections.reduce((sum, section) => sum + section.clientHeight, 0);
  }

  let sectionsAboveHeader = getSectionsAboveHeader();
  let height = calculateHeight(sectionsAboveHeader);

  let lastScrollY = window.scrollY;
  let lastDirection = 0; // 1 = down, -1 = up
  let ticking = false;
  const threshold = 5; // Ignore tiny scrolls

  function updateHeader() {
    const currentScrollY = window.scrollY;

    // --- iPHONE SAFARI FIX: At top, always show header ---
    if (currentScrollY === 0) {
      header.style.marginTop = `${height}px`;
      header.style.top = `${height}px`;
      sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
      header.classList.remove('header-hidden');

      lastScrollY = 0;
      lastDirection = -1;
      ticking = false;
      return;
    }
    // ------------------------------------------------------

    const diff = currentScrollY - lastScrollY;

    if (Math.abs(diff) > threshold) {
      const direction = diff > 0 ? 1 : -1;

      if (direction !== lastDirection) {
        if (direction === 1) {
          // Scrolling down → hide header
          header.classList.add('header-hidden');
          header.style.marginTop = 0;
          header.style.top  = 0;
          sectionsAboveHeader.forEach(sec => sec.classList.remove('show__scroller'));
        } else {
          // Scrolling up → show header
          header.style.marginTop = `${height}px`; 
          header.style.top = `${height}px`; 
          sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
          header.classList.remove('header-hidden');
        }
        lastDirection = direction;
      }

      lastScrollY = currentScrollY;
    }

    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });

  // Recalculate sections and height on resize
  window.addEventListener('resize', () => {
    sectionsAboveHeader = getSectionsAboveHeader();
    height = calculateHeight(sectionsAboveHeader);

    // Ensure header is correctly positioned if currently visible
    if (!header.classList.contains('header-hidden')) {
      header.style.marginTop = `${height}px`;
      header.style.top = `${height}px`;
      sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
    }
  });
});


/* ------ HP VIDEO HERO ------ */
function setHeroHeight() {
  var viewportHeight = window.innerHeight;
  // Set height attribute of all <video> elements
  document.querySelectorAll('video').forEach(function(video) {
    video.setAttribute('height', viewportHeight);
  });
  // Set CSS height of all <video-element> elements
  document.querySelectorAll('video-element').forEach(function(el) {
    el.style.height = viewportHeight + 'px';
  });
  // Remove specific classes from all <motion-element> elements with class 'media'
  document.querySelectorAll('motion-element.media').forEach(function(el) {
    el.classList.remove('media', 'media--adapt', 'mb:media--adapt');
  });
}
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('index-template')) {
    setHeroHeight();
    window.addEventListener('resize', setHeroHeight);
  }
});

/* ------ GORGIAS ------ */
  //Hide Gorgias and show on scroll
  //if (document.body.classList.contains('index-template')) {
    window.addEventListener("scroll", function () {
      const gcc = document.getElementById("gorgias-chat-container");
      if (gcc) {
        if (window.scrollY > 100) {
          gcc.style.display = "block";
        } else {
          gcc.style.display = "none";
        }
      }
    });
  //}

/* ------ PLP ------ */
  // Script to replace the swatch click from redirect to rather display the variant image
  $('body').on('click', '.product-card__swatches ul.swatches--product-card li', function(event) {
    // Get the ATC button
    var atcButton = $(this).closest('.product-card').find('button.add-to-cart');
    // Get the swatch variant ID
    var variantId = $(this).data('variant-id');
    atcButton.attr('data-variant-id', variantId);
    // Get the swatch availability 
    let variantStock = $(this).data('stock');

    // Get the new image paths for primary and secondary images
    var getswatch = $(this).data('variant-img');
    var getswatchhover = $(this).data('variant-hover');
    
    // Cache the product card and images
    var $productCard = $(this).closest('.product-card');
    var $pImage = $productCard.find('.product-card__image--main img');
    var $sImage = $productCard.find('.product-card__image--second img');
    
    // Get current src and srcset for primary and secondary images
    var primarySrc = $pImage.attr('src');
    var primarySrcset = $pImage.attr('srcset');
    var secondarySrc = $sImage.attr('src');
    
    // Update the image sources
    var newPSrc = primarySrc.replace(/files\/[^?]+/, '/' + getswatch);
    var newPSrcset = primarySrcset ? primarySrcset.replace(/files\/[^?]+/g, '/' + getswatch) : null;
    var newSSrc = secondarySrc.replace(/\/([^\/]+)(\?v=[^&]+)/, '/'+ getswatchhover + '$2');

    // Set the updated src and srcset back to the images
    $pImage.attr('src', newPSrc);
    if (newPSrcset) {
      $pImage.attr('srcset', newPSrcset);
    }

    $sImage.attr('src', newSSrc);
    if (getswatchhover) {
      // Generate srcset for secondary image
      const baseSSrc = newSSrc.split('?')[0];
      const querySSrc = newSSrc.includes('?') ? newSSrc.split('?')[1] + '&' : '';
      
      const newSSrcset = `
        ${baseSSrc}?${querySSrc}width=270 270w,
        ${baseSSrc}?${querySSrc}width=450 450w,
        ${baseSSrc}?${querySSrc}width=600 600w
      `;
      
      $sImage.attr('srcset', newSSrcset.trim());
    } else {
      // If no hover image provided, fallback to primary srcset
      $sImage.attr('srcset', newPSrcset);
    }

    if(variantStock == false ) {
      atcButton.prop('disabled', true).find('.add-to-cart__text').text('Out of Stock');
    } else {
      atcButton.prop('disabled', false).find('.add-to-cart__text').text('Add to Cart');
    }
  });

// Add to Cart on button click
document.body.addEventListener('click', function(event) {
  // Check if the clicked element matches the selector '.product-card button.add-to-cart'
  if (event.target.matches('.product-card button.add-to-cart')) {
    event.preventDefault();

    const button = event.target;
    // Find closest .product-card ancestor
    const productCard = button.closest('.product-card');
    if (!productCard) return;

    // Find the add-to-cart button inside that product card (usually it's the same button clicked)
    const atcButton = productCard.querySelector('button.add-to-cart');

    // Get data attributes from clicked button
    const variantId = button.getAttribute('data-variant-id');
    // dataset property parses data attributes; but beware false might be string
    const variantStock = button.getAttribute('data-stock');

    // Check if variantStock is not false (assuming it's a string)
    if (variantStock !== 'false') {
      addToCart(variantId, 1);
    }
  }
});

/* ------ ACCESSORIES ------ */
  $(document).ready(function() {
    $('.collection-template.accessories #ProductCount').text('0 products');
    $('#acc_select').change(function() {
      let selectedOption = $('#acc_select option:selected');
      let selectedDataTag = selectedOption.data('tag');
      let selectedTitle = selectedOption.text();
  
      $('#ProductGridContainer .f-column').show();
  
      $('#ProductGridContainer .f-column').each(function() {
        let tags = $(this).attr('data-tag'); // raw string, e.g. "acc_all,acc_go,acc_mega"
        
        // Check if selectedDataTag is included
        if (!tags || !tags.includes(selectedDataTag)) {
          $(this).hide();
        }
      });
  
      let visibleCount = $('#ProductGridContainer .f-column:visible').length;
      $('.collection-template.accessories #ProductCount').text(visibleCount + ' products');

      if (selectedTitle.includes('Select')) {
        $('.accessories_title').hide();
      } else {
        $('.accessories_title').fadeIn();
        $('.accessories_title h3').text('Shop ' + selectedTitle + ' Accessories').prop('hidden', false);
      }
    });
  });


/* ------ PDP ------ */

  // Bundle Switcher
  if (window.location.pathname.includes('/products/')) {
    document.addEventListener('DOMContentLoaded', () => {
      const dropdown = document.getElementById('product-bundle');
      const toggle = document.getElementById('bundle-toggle');
      const list = dropdown.querySelector('ul');
      const items = dropdown.querySelectorAll('li input[type="radio"]');

      // Handle the radio reorder behavior
      items.forEach(input => {
        input.addEventListener('click', (e) => {
          e.preventDefault();
          const link = input.parentElement.getAttribute('href');
          // Redirect after a short delay
          setTimeout(() => {
            window.location.href = link;
          }, 80);
        });
      });

      // Toggle dropdown open/close
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdown.classList.toggle('open');
      });

      // Handle dropdown item clicks (non-radio version)
      const lis = dropdown.querySelectorAll('li');
      lis.forEach(item => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          const title = item.dataset.title;
          const url = item.dataset.url;

          // Update visible label
          toggle.textContent = title;

          // Mark active
          lis.forEach(li => li.classList.remove('active_bundle'));
          item.classList.add('active_bundle');

          // Close dropdown smoothly
          dropdown.classList.remove('open');

          // Redirect after animation
          setTimeout(() => {
            window.location.href = url;
          }, 300);
        });
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('open');
        }
      });
    });
  };

// Custom notice (Ship on data)
  window.addEventListener('load', function () {
    var custom_line_item = $('.product__block--variant_picker .color_wrap input[type="radio"]:checked').attr('custom');

    // Create container if it doesn't exist
    if (!$('.product__block--line-item').length) {
      $('<div class="product__block product__block--line-item"></div>')
        .insertBefore('.product__block--buy_buttons');
    }

    // Set content and show/hide
    if (custom_line_item && custom_line_item.length >= 2) {
      $('.product__block--line-item')
        .html(custom_line_item)
        .show();
    } else {
      $('.product__block--line-item')
        .hide()
        .empty();
    }
  });

  $(document).on('change', '.product__block--variant_picker .color_wrap input[type="radio"]', function () {
    var custom_line_item = $(this).attr('custom');

    if (custom_line_item && custom_line_item.length >= 2) {
      $('.product__block--line-item')
        .html(custom_line_item)
        .show();
    } else {
      $('.product__block--line-item')
        .hide()
        .empty();
    }
  });


// Description limit height (Show/Hide)
  const maxPreviewHeight = 130;
  $('.product__block[data-block="description"] .accordion-details__content').each(function () {
    const $content = $(this);
    $content.wrap('<div class="accordion-details__content-wrapper"></div>');
    
    const $wrapper = $content.parent();
    
    if ($content[0].scrollHeight > maxPreviewHeight) {
      $wrapper.after('<span class="read-more-toggle">Show more</span>');
    }
  });

  $(document).on('click', '.read-more-toggle', function () {
    const $btn = $(this);
    const $wrapper = $btn.prev('.accordion-details__content-wrapper');
    const isExpanded = $wrapper.toggleClass('expanded').hasClass('expanded');

    $btn.text(isExpanded ? 'Show less' : 'Show more');
  });


  (function () {
  // Early exit if section isn't on this page
  if (!document.getElementById('beast-compare-blenders')) return;

  const select1 = document.getElementById('compare_1_select');
  const select2 = document.getElementById('compare_2_select');
  const select3 = document.getElementById('compare_3_select');
  const isMobile = $(window).width() <= 768;

  // Disable options already selected in other selects (desktop only)
  function updateSelectOptions() {
    if (isMobile) return;
    const vals = [select1.value, select2.value, select3.value];
    [select1, select2, select3].forEach(function (sel, i) {
      const others = vals.filter((_, j) => j !== i);
      Array.from(sel.options).forEach(function (opt) {
        opt.disabled = others.includes(opt.value);
      });
    });
  }

  // Show only selected columns, hide the rest
  function hideCompare() {
    const selv1 = select1.value;
    const selv2 = select2.value;
    const selv3 = select3.value;

    document.querySelectorAll('.beast_compare_col').forEach(function (div) {
      const id = div.getAttribute('data-prod');
      const visible = isMobile
        ? id === selv1 || id === selv2
        : id === selv1 || id === selv2 || id === selv3;
      $(div).toggle(visible);
    });
  }

  // Equalise row heights across columns
  function equaliseRows() {
    const columns = document.querySelectorAll('.beast_compare_col');
    if (!columns.length) return;

    const rows = columns[0].querySelectorAll('.grid_line').length;
    for (let i = 0; i < rows; i++) {
      const rowLines = Array.from(columns).map(col => col.querySelectorAll('.grid_line')[i]);
      const maxH = rowLines.reduce((max, line) => Math.max(max, line.offsetHeight), 0);
      rowLines.forEach(line => (line.style.height = maxH + 'px'));
    }
  }

  window.addEventListener('load', function () {
    // Show/hide section wrapper based on column count
    const colCount = document.querySelectorAll('.beast_compare_col').length;
    $('#beast_compare').addClass(colCount === 1 ? 'one_ccol' : 'two_ccol').show();

    // Set default visible images per column (first swatch)
    $('#beast_compare .cb_img').hide();
    $('.beast_compare_col').each(function () {
      const defSwatch = $('.beast_color_block:first', this).data('swatch');
      $(this).find('.cb_img').filter(function () {
        return $(this).data('color') === defSwatch;
      }).show();
      $(this).find('.beast_color_block').filter(function () {
        return $(this).data('swatch') === defSwatch;
      }).addClass('ccolur_actv');
    });

    equaliseRows();
  });

  // Color swatch click
  $(document).on('click', '.beast_color_block', function () {
    const $col = $(this).closest('.beast_compare_col');
    $col.find('.beast_color_block').removeClass('ccolur_actv');
    $(this).addClass('ccolur_actv');

    const selSwatch = $(this).data('swatch');
    $col.find('.cb_img').hide();
    $col.find('.cb_img').filter(function () {
      return $(this).data('color') && $(this).data('color').includes(selSwatch);
    }).fadeIn();
  });

  $(document).ready(function () {
    // Set default selected options
    $('#compare_1_select option:eq(0)').prop('selected', true);
    $('#compare_2_select option:eq(1)').prop('selected', true);

    if (isMobile) {
      $('#compare_3_select').hide();
      // Cross-disable on mobile
      $('#compare_2_select option[value="' + select1.value + '"]').prop('disabled', true);
      $('#compare_1_select option[value="' + select2.value + '"]').prop('disabled', true);
    } else {
      $('#compare_3_select option:eq(2)').prop('selected', true);
    }

    updateSelectOptions();
    hideCompare();

    // Change handlers — parameterised to avoid repetition
    function makeChangeHandler(sel, order, otherSelects) {
      $(sel).on('change', function () {
        hideCompare();
        const val = $(this).val();
        $('.beast_compare_col[data-prod="' + val + '"]').css('order', order).show();

        if (isMobile) {
          // Re-enable all then disable the newly selected value in the other select
          otherSelects.forEach(function (other) {
            $(other).find('option').prop('disabled', false);
            $(other).find('option[value="' + val + '"]').prop('disabled', true);
          });
        } else {
          updateSelectOptions();
        }
      });
    }

    makeChangeHandler(select1, 0, [select2]);
    makeChangeHandler(select2, 1, [select1]);
    if (!isMobile) makeChangeHandler(select3, 2, []);

    select1.addEventListener('change', updateSelectOptions);
    select2.addEventListener('change', updateSelectOptions);
    select3.addEventListener('change', updateSelectOptions);
  });
})();

// Reduced motion: stop autoplaying videos and let the user start them with native controls
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function stopAutoplayVideos() {
    if (!reduceMotion.matches) return;
    document.querySelectorAll('video[autoplay]').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.pause();
      video.controls = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stopAutoplayVideos);
  } else {
    stopAutoplayVideos();
  }
  reduceMotion.addEventListener('change', stopAutoplayVideos);
})();
